import { CSSProperties, useCallback, useState } from 'react';
import Flex from '../Flex';
import { useThemeToken } from '@/hooks';

const itemStyle: CSSProperties = {
  border: '2px solid #cccccc',
  backgroundColor: '#efefef',
  aspectRatio: '1/1',
  borderRadius: '0.75rem',
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'ease-in-out 175ms'
};

export interface CardSelectorProps<T> {
  items: T[];
  gap?: number | string;
  itemSize?: number | string;
  render: (item: T, index: number, selected: boolean) => React.ReactElement | string;
  onChange?: (item: T, index: number) => void;
}

export function CardSelector<T>({
  items,
  render,
  itemSize,
  onChange,
  gap
}: CardSelectorProps<T>) {

  if (!itemSize) itemSize = '100px';
  const { colorPrimary, colorPrimaryLight } = useThemeToken();

  const [selected, setSelected] = useState<number>(null);
  const handleClick = useCallback((item: T, i: number) => {
    setSelected(i);
    if (onChange) {
      onChange(item, i);
    }
  }, [onChange]);

  return (
    <Flex
      gap={gap ?? '1.5rem'}
      wrap="wrap"
      direction="row"
      style={{ width: '100%' }}
      align="center"
      justify="center"
      className="app-card-selector"
    >
      {items.map((item, i) => (
        <Flex
          gap={0}
          key={i}
          inlineFlex
          align="center"
          justify="center"
          style={{
            ...itemStyle,
            width: itemSize,
            height: itemSize,
            ...(selected !== i ? {
              color: 'red',
            } : {
              backgroundColor: colorPrimaryLight,
              border: `2px solid ${colorPrimary}`
            })
          }}
          onClick={() => handleClick(item, i)}>
          {render(item, i, i === selected)}
        </Flex>
      ))}
    </Flex>
  );
}

export default CardSelector;
